export enum CalculatorRules {
  GET_CALCULATOR_RULES_REQUEST = '@calculatorrules/GET_CALCULATOR_RULES_REQUEST',
  GET_CALCULATOR_RULES_SUCCESS = '@calculatorrules/GET_CALCULATOR_RULES_SUCCESS',
  GET_CALCULATOR_RULES_FAIL = '@calculatorrules/GET_CALCULATOR_RULES_FAIL',

  UPDATE_CALCULATOR_RULES_REQUEST = '@calculatorrules/UPDATE_CALCULATOR_RULES_REQUEST',
  UPDATE_CALCULATOR_RULES_SUCCESS = '@calculatorrules/UPDATE_CALCULATOR_RULES_SUCCESS',
  UPDATE_CALCULATOR_RULES_FAIL = '@calculatorrules/UPDATE_CALCULATOR_RULES_FAIL',

  GENERATE_CALCULATOR_RULES_REQUEST = '@calculatorrules/GENERATE_CALCULATOR_RULES_REQUEST',
  GENERATE_CALCULATOR_RULES_SUCCESS = '@calculatorrules/GENERATE_CALCULATOR_RULES_SUCCESS',
  GENERATE_CALCULATOR_RULES_FAIL = '@calculatorrules/GENERATE_CALCULATOR_RULES_FAIL',
}
